import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Alert,
  Button,
  Chip,
  FormControlLabel,
  Grid,
  Paper,
  Stack,
  Switch,
  Typography,
} from '@mui/material';
import {
  runHealAllAsync,
  selectHealRunError,
  selectHealRunLoading,
  selectHealRunReport,
} from '../../../redux/locatorDrift/locatorDriftSlice';
import HealRunReport from './HealRunReport';
import { healAllPanelStyles } from './healingStyles';

export default function HealAllPanel() {
  const dispatch = useDispatch();
  const healRunLoading = useSelector(selectHealRunLoading);
  const healRunError = useSelector(selectHealRunError);
  const healRunReport = useSelector(selectHealRunReport);
  const [fromVersion, setFromVersion] = useState('');
  const [toVersion, setToVersion] = useState('');
  const [platform, setPlatform] = useState('android');
  const [autoThreshold, setAutoThreshold] = useState('0.80');
  const [dryRun, setDryRun] = useState(true);

  return (
    <Paper variant="outlined" sx={healAllPanelStyles.root}>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={2}
        alignItems={{ xs: 'stretch', md: 'flex-end' }}
        sx={healAllPanelStyles.header}
      >
        <Typography variant="subtitle2" fontWeight={800} sx={healAllPanelStyles.title}>
          Heal All - predict and auto-apply between two versions
        </Typography>
        <Chip size="small" label="SH-08 orchestration" />
      </Stack>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid item xs={12} md={3}>
          <input
            value={fromVersion}
            onChange={(event) => setFromVersion(event.target.value)}
            placeholder="Core6841"
            style={healAllPanelStyles.input}
          />
          <Typography variant="caption" color="text.secondary">
            From version
          </Typography>
        </Grid>
        <Grid item xs={12} md={3}>
          <input
            value={toVersion}
            onChange={(event) => setToVersion(event.target.value)}
            placeholder="Core7074"
            style={healAllPanelStyles.input}
          />
          <Typography variant="caption" color="text.secondary">
            To version
          </Typography>
        </Grid>
        <Grid item xs={12} md={2}>
          <select
            value={platform}
            onChange={(event) => setPlatform(event.target.value)}
            style={healAllPanelStyles.input}
          >
            <option value="android">android</option>
            <option value="ios">ios</option>
          </select>
          <Typography variant="caption" color="text.secondary">
            Platform
          </Typography>
        </Grid>
        <Grid item xs={12} md={2}>
          <input
            value={autoThreshold}
            onChange={(event) => setAutoThreshold(event.target.value)}
            type="number"
            min="0"
            max="1"
            step="0.05"
            style={healAllPanelStyles.input}
          />
          <Typography variant="caption" color="text.secondary">
            Auto threshold
          </Typography>
        </Grid>
        <Grid item xs={12} md={2}>
          <Stack spacing={1}>
            <FormControlLabel
              control={
                <Switch checked={dryRun} onChange={(event) => setDryRun(event.target.checked)} />
              }
              label="Dry-run"
            />
            <Button
              variant="contained"
              disabled={healRunLoading || !fromVersion || !toVersion || fromVersion === toVersion}
              onClick={() =>
                dispatch(
                  runHealAllAsync({
                    from_version: fromVersion.trim(),
                    to_version: toVersion.trim(),
                    platform,
                    dry_run: dryRun,
                    auto_threshold: Number(autoThreshold || 0.8),
                  }),
                )
              }
            >
              {healRunLoading ? 'Running...' : 'Run Heal'}
            </Button>
          </Stack>
        </Grid>
      </Grid>
      {healRunError && (
        <Alert severity="error" sx={healAllPanelStyles.error}>
          {healRunError}
        </Alert>
      )}
      {healRunReport && <HealRunReport report={healRunReport} />}
    </Paper>
  );
}
